export interface PanelKPICardProps {
  props: {
    label: string;
    value: string;
    trend?: string;
    trendDirection?: 'up' | 'down' | 'neutral';
  };
}

export function PanelKPICard({ props }: PanelKPICardProps) {
  const { label, value, trend, trendDirection } = props;

  const trendColorClass =
    trendDirection === 'up'
      ? 'text-sd-success'
      : trendDirection === 'down'
        ? 'text-sd-error'
        : 'text-sd-text-muted';

  const trendArrow =
    trendDirection === 'up' ? '▲' : trendDirection === 'down' ? '▼' : '–';

  return (
    <div className="bg-sd-surface border border-sd-border/20 rounded-sd-md shadow-sd-sm px-sd-3 py-sd-2 hover:shadow-sd-md hover:border-sd-border/40 transition-all duration-200">
      {/* Label */}
      <p className="text-sd-xs text-sd-text-muted uppercase tracking-wide mb-0.5 select-none">
        {label}
      </p>

      {/* Value */}
      <p className="text-sd-2xl font-bold text-sd-text tabular-nums leading-tight">
        {value}
      </p>

      {/* Trend */}
      {trend && (
        <p className={`text-sd-xs font-medium mt-0.5 flex items-center gap-0.5 ${trendColorClass}`}>
          <span aria-hidden="true">{trendArrow}</span>
          {trend}
        </p>
      )}
    </div>
  );
}
